import Vue from 'vue';
import MagicWand from 'magic-wand-tool';
Vue.use(MagicWand);

export default MagicWand;
